var map = {
	"./call-to-action/style.scss": "./template/blocks/call-to-action/style.scss",
	"./care-package/style.scss": "./template/blocks/care-package/style.scss",
	"./care-steps/style.scss": "./template/blocks/care-steps/style.scss",
	"./care-why-choose/style.scss": "./template/blocks/care-why-choose/style.scss",
	"./faq-item/style.scss": "./template/blocks/faq-item/style.scss",
	"./faq/style.scss": "./template/blocks/faq/style.scss",
	"./hero-block/style.scss": "./template/blocks/hero-block/style.scss",
	"./hero-services/style.scss": "./template/blocks/hero-services/style.scss",
	"./info-icon/style.scss": "./template/blocks/info-icon/style.scss",
	"./logo-slider/style.scss": "./template/blocks/logo-slider/style.scss",
	"./post-slider/style.scss": "./template/blocks/post-slider/style.scss",
	"./realization-features/style.scss": "./template/blocks/realization-features/style.scss",
	"./realization-hero/style.scss": "./template/blocks/realization-hero/style.scss",
	"./services-advantages/style.scss": "./template/blocks/services-advantages/style.scss",
	"./services-boxes-icons/style.scss": "./template/blocks/services-boxes-icons/style.scss",
	"./services-boxes/style.scss": "./template/blocks/services-boxes/style.scss",
	"./services-image-text-box/style.scss": "./template/blocks/services-image-text-box/style.scss",
	"./services-links/style.scss": "./template/blocks/services-links/style.scss",
	"./services-why-us/style.scss": "./template/blocks/services-why-us/style.scss",
	"./text-image/style.scss": "./template/blocks/text-image/style.scss",
	"./toggle-text/style.scss": "./template/blocks/toggle-text/style.scss",
	"./wrapper-block/style.scss": "./template/blocks/wrapper-block/style.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./template/blocks sync recursive style\\.scss$";